import { Router, ActivatedRoute, ParamMap, NavigationExtras } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../_infrastructure/Alerts/alert.service';
import { DOCUMENT } from '@angular/common';
import { SystemInformationService } from '../_infrastructure/SystemInformation/SystemInformationService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';
import { SessionStorageService } from '../_infrastructure/SessionStorageService/SessionStorageService';

@Component({
    selector: 'exsub-confirm-submission',
    templateUrl: './exsub-confirm-submission.component.html',
    standalone: false
})

export class ExSubsConfirmSubmissionComponent implements OnInit, OnDestroy {
  
  public subscriberNumber: string;
  public isService: boolean;
  public serviceCode: string;
  public atendimento: string;
  public tipoUtilizador: string;

  public workflowDefinition: models.WorkflowInformationVM = <models.WorkflowInformationVM>{};
  // PIT 40803 \\
  public destinoRouter: string;

  constructor(private changeDetector: ChangeDetectorRef, private http: HttpClient, private activeRoute: ActivatedRoute,
    private translateService: TranslateService, private router: Router, @Inject(DOCUMENT) private document: Document,
    private alertService: AlertService, private systemInfo: SystemInformationService, private securityService: SecurityService,
    private sessionStorageService: SessionStorageService) {

  }

  ngOnInit(): void {

    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      //const oriValue = JSON.parse(dadosOrigem);

      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\

    //logica se necessario para atualização da notificação a mostrar mais especifica
    this.activeRoute.paramMap.subscribe((params: ParamMap) => {

      this.subscriberNumber = <any>params.get('subscriberNumber');

    });

  }

  ngAfterViewInit(): void {
    //load notificaçao 
    if (this.subscriberNumber != "null") {
      this.alertService.success(this.translateService.instant(this.subscriberNumber == "-1" || this.subscriberNumber == "0" ? "SubmissionExSubscriberSuccessManifest.ConfirmSubmissionText" : "SubmissionExSubscriberSuccessManifest.ConfirmSubmissionTextService"));
    } else {
      this.alertService.success(this.translateService.instant("SubmissionExSubscriberSuccessManifest.RejectionSuccessText"));
    }
    

  }



  //LIFECYCLE
  ngOnDestroy(): void {

  }


  backToHomePageButton() {
    this.router.navigate(['workflowSearch']);
  }


}
